import { z } from 'zod';
/**
 * The topics of the help (ADR-021 §6): each has an article in the firm app, and the questions
 * people ask about it (FAQ), kept by the Kanos team in the platform.
 */
export const HelpTopic = z
    .enum([
    'getting-started',
    'obligations',
    'base-data',
    'team',
    'appearance-and-domains',
    'inquiries',
    'intakes',
    'interfaces',
    'privacy',
    'billing',
    'account',
])
    .meta({ id: 'HelpTopic' });
/** Whom a question is for: the people of the firms, or their clients in the portal. */
export const FaqAudience = z.enum(['firm', 'client']).meta({ id: 'FaqAudience' });
export const FaqEntryInput = z
    .object({
    topic: HelpTopic,
    audience: FaqAudience,
    question: z.string().trim().min(5).max(300),
    /** Plain text; an empty line starts a new paragraph. */
    answer: z.string().trim().min(10).max(5000),
    /** Order within the topic, smallest first. */
    position: z.int().min(0).max(999),
    /** Only a published question is shown in the apps. */
    published: z.boolean(),
})
    .meta({ id: 'FaqEntryInput' });
export const FaqEntry = FaqEntryInput.extend({
    id: z.uuid(),
    updatedAt: z.iso.datetime({ offset: true }),
}).meta({ id: 'FaqEntry' });
export const FaqEntryList = z.array(FaqEntry).meta({ id: 'FaqEntryList' });
export const FaqParams = z.object({ faqId: z.uuid() }).meta({ id: 'FaqParams' });
/** The answer as paragraphs, as it was written. */
export const paragraphsOf = (answer) => answer
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
/** The topics as the Kanos team chooses them when writing a question. */
export const helpTopicLabel = {
    'getting-started': 'Erste Schritte',
    obligations: 'Pflichten der Kanzlei',
    'base-data': 'Basisdaten, Berufsträger und Standorte',
    team: 'Team und Admin-Rechte',
    'appearance-and-domains': 'Erscheinungsbild und Portal-Domains',
    inquiries: 'Anfragen über das Mandantenportal',
    intakes: 'Mandatsaufnahme und Geldwäscheprävention',
    interfaces: 'Schnittstellen',
    privacy: 'Datenschutz',
    billing: 'Tarife und Abrechnung',
    account: 'Konto und Anmeldung',
};
export const faqAudienceLabel = {
    firm: 'Kanzlei-App',
    client: 'Mandantenportal',
};
//# sourceMappingURL=help.js.map